<template>
  <tr>
    <td>{{ item.linea }}</td>
    <td>{{ item.articulo.id }}</td>
    <td>{{ item.articulo.descripcion }}</td>
    <td class="has-text-centered">{{ unidadMedida }}</td>
    <td class="has-text-right">{{ item.stock }}</td>
    <td class="has-text-right">{{ cantidadSolicitada }}</td>
    <td class="has-text-right">{{ cantidadFacturada }}</td>
    <td class="has-text-right">{{ cantidadPickeada }}</td>
    <td class="has-text-right">{{ pendiente }}</td>
    <td></td>
  </tr>
</template>

<script>
export default {
  name: 'PedidoItemDetalle',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    cantidadEntregada() {
      return this.item.cantidadEntregada * this.multiplo
    },
    cantidadFacturada() {
      return this.item.cantidadFacturada * this.multiplo
    },
    cantidadPickeada() {
      return this.item.cantidadPickeada * this.multiplo
    },
    cantidadSolicitada() {
      return this.item.cantidadSolicitada * this.multiplo
    },
    hayMedidaInventario() {
      return (
        this.item.unidadMedida !==
        (this.item.unidadMedidaInventario ?? this.item.unidadMedida)
      )
    },
    multiplo() {
      if (this.item.multiplo && this.item.multiplo > 0)
        return this.item.multiplo
      return 1
    },
    pendiente() {
      return (
        (this.item.cantidadSolicitada - this.item.cantidadEntregada) *
        this.multiplo
      )
    },
    unidadMedida() {
      return this.hayMedidaInventario
        ? this.item.unidadMedidaInventario
        : this.item.unidadMedida
    }
  }
}
</script>

<style lang="scss" scoped>
$checkbox-background-color: white;

td {
  position: relative;
}
</style>
